import { Link, useLocation } from 'react-router';
import { useChainId } from 'wagmi';
import {
  LayoutDashboard,
  Users,
  Coins,
  Lock,
  Layers,
  Settings,
  Wallet,
  FileCode,
} from 'lucide-react';
import { cn } from '@/shared/lib/utils';
import { galactica, galacticaCassiopeia } from '@/shared/config';

const navigation = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard },
  { name: 'Claimr', href: '/claimr', icon: Users },
  { name: 'gUBI Distribution', href: '/distribution', icon: Coins },
  { name: 'GNET Vesting', href: '/gnet-vesting', icon: Wallet },
  { name: 'Staking', href: '/staking', icon: Lock },
  { name: 'Index Pool', href: '/index-pool', icon: Layers },
  { name: 'Settings', href: '/settings', icon: Settings },
  { name: 'API Docs', href: '/api-docs', icon: FileCode },
];

export function Sidebar() {
  const location = useLocation();
  const chainId = useChainId();
  const currentChain = chainId === galactica.id ? galactica : galacticaCassiopeia;

  return (
    <aside className="fixed inset-y-0 left-0 w-64 bg-white border-r border-gray-200">
      {/* Logo */}
      <div className="h-16 flex items-center px-6 border-b border-gray-200">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#f26f56] to-[#f49756] flex items-center justify-center">
            <span className="text-white font-bold text-sm">G</span>
          </div>
          <span className="font-semibold text-lg text-[#2b2b2b]">GUBI Admin</span>
        </Link>
      </div>

      {/* Navigation */}
      <nav className="p-4 space-y-1">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href;
          const Icon = item.icon;

          if (item.disabled) {
            return (
              <div
                key={item.name}
                className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-gray-400 cursor-not-allowed"
              >
                <Icon className="w-5 h-5" />
                <span>{item.name}</span>
                <span className="ml-auto text-xs bg-gray-100 px-2 py-0.5 rounded">Soon</span>
              </div>
            );
          }

          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                isActive
                  ? 'bg-[#f26f56]/10 text-[#f26f56]'
                  : 'text-[#807f7e] hover:bg-gray-100 hover:text-[#2b2b2b]'
              )}
            >
              <Icon className="w-5 h-5" />
              <span>{item.name}</span>
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
        <div className="text-xs text-[#807f7e]">
          <div className="flex items-center gap-2">
            <div className={`w-2 h-2 rounded-full ${currentChain.testnet ? 'bg-yellow-500' : 'bg-green-500'}`} />
            <p>{currentChain.name}</p>
          </div>
          <p className="mt-1">Chain ID: {currentChain.id}</p>
        </div>
      </div>
    </aside>
  );
}
